export default __webpack_public_path__ + "static/media/stage2_documents_1.f2200331.jpg";